// @ts-nocheck
import { USER_ROLES } from "../../staticData/userRoles";

/**
 * contracts = true -> enable, false -> disable
 * groupedStatus = true -> grouped, false -> ungrouped
 * ratePages = true -> available, false -> disabled
 * rateList = true -> use rate list on estimate, false -> don't use
 * freelancelogin = true -> allow freelance login, false -> don't
 * revenueReport = true -> show revenue report, false -> don't
 * mediaGallery = true -> show mediagallery everywhere, false -> don't
 * chatMessageStatus = true -> show option to view chat message status, false -> don't
 * budgetTier = true -> show budget tiers
 */
export const FRONTEND_CONFIG = {
  contracts: false,
  groupedStatus: false,
  ratePages: true,
  rateList: true,
  freelanceLogin: true,
  revenueReport: true,
  // Off since 23/09/2026: replaced by Show Media (participant photos/videos with image-rights consent).
  // Old files stay in position_media_files; routes untouched.
  mediaGallery: false,
  mediaGalleryAllEvents: false,
  chatMessageStatus: false,
  tableToolBar: {
    dashboard: true,
    adminPositions: true,
    clientPositions: true,
  },
  positionsList: true,
  payrollReport: false,
  contractorConsentPages: false,
  budgetTier: true,
};

/**
 * message restrictions
 */
export const MESSAGE_STATUS_CONFIG = {
  view_own_status: {
    [USER_ROLES.SUPERADMIN]: true,
    [USER_ROLES.ADMIN]: true,
    [USER_ROLES.CLIENT]: true,
    [USER_ROLES.COORDINATOR]: true,
    [USER_ROLES.FREELANCE_EC]: true,
  },
  view_other_status: {
    [USER_ROLES.SUPERADMIN]: true,
    [USER_ROLES.ADMIN]: true,
    [USER_ROLES.CLIENT]: false,
    [USER_ROLES.COORDINATOR]: false,
    [USER_ROLES.FREELANCE_EC]: false,
  },
  view_last_seen: {
    [USER_ROLES.SUPERADMIN]: true,
    [USER_ROLES.ADMIN]: true,
    [USER_ROLES.CLIENT]: false,
    [USER_ROLES.COORDINATOR]: false,
    [USER_ROLES.FREELANCE_EC]: false,
  },
};

/**
 * position categories
 */
export const POSITION_CATEGORIES = [
  "GS Audio",
  "Lighting",
  "Video",
  "I/T",
  "Show Management Data",
  "Meeting Rooms/Breakouts",
  "Exhibits",
  "Scenic",
  "Rigging",
  "Equipment Operators",
];

/**
 * doesn't exist email
 */
export const DOES_NOT_EXIST = {
  email: "emaildoesnotexistforthisuser.com",
};

/**
 * contractor type which have agreemnts
 */
export const AGREEMENT_CONTRACTOR_TYPES = ["V.C.", "1099", "w2"];

/**
 * wait time before delete action in seconds
 */
export const WAIT_TIME = {
  deletePosition: 5,
};

/**
 * contractor types for workmarket id
 */
export const WORKMARKET_CONTRACTOR_TYPES = ["V.C.", "1099"];